import {CategoriaWizard} from './wizard-state.model';

export interface SegmentoTemplate {
  segmento: string;
  icone: string;
  categorias: CategoriaWizard[];
}

export interface SegmentoDisponivel {
  nome: string;
  imagem: string;
  alt: string;
}

export const SEGMENTOS_DISPONIVEIS: SegmentoDisponivel[] = [
  {nome: 'Pizzaria', imagem: 'assets/wizard/segmentos/pizzaria.svg', alt: 'Ilustracao de uma fatia de pizza'},
  {nome: 'Hamburgueria', imagem: 'assets/wizard/segmentos/hamburgueria.svg', alt: 'Ilustracao de um hamburguer'},
  {nome: 'Açaí', imagem: 'assets/wizard/segmentos/acai.svg', alt: 'Ilustracao de um copo de acai'},
  {nome: 'Marmitaria', imagem: 'assets/wizard/segmentos/marmitaria.svg', alt: 'Ilustracao de uma marmita'},
  {nome: 'Sushi', imagem: 'assets/wizard/segmentos/sushi.svg', alt: 'Ilustracao de combinados de sushi'},
  {nome: 'Restaurante', imagem: 'assets/wizard/segmentos/restaurante.svg', alt: 'Ilustracao de um prato servido'},
  {nome: 'Lanchonete', imagem: 'assets/wizard/segmentos/lanchonete.svg', alt: 'Ilustracao de um lanche e refrigerante'},
  {nome: 'Doceria', imagem: 'assets/wizard/segmentos/doceria.svg', alt: 'Ilustracao de um cupcake'},
  {nome: 'Padaria', imagem: 'assets/wizard/segmentos/padaria.svg', alt: 'Ilustracao de um pao artesanal'},
  {nome: 'Pastelaria', imagem: 'assets/wizard/segmentos/pastelaria.svg', alt: 'Ilustracao de um pastel'},
  {nome: 'Outro', imagem: 'assets/wizard/segmentos/outro.svg', alt: 'Ilustracao de uma loja generica'}
];

export const TEMPLATES_SEGMENTO: Record<string, SegmentoTemplate> = {
  'Pizzaria': {
    segmento: 'Pizzaria',
    icone: 'fas fa-pizza-slice',
    categorias: [
      {
        nome: 'Pizzas Tradicionais',
        produtos: [
          {nome: 'Margherita', descricao: 'Molho de tomate, mussarela e manjericão fresco', preco: 35, categoria: 'Pizzas Tradicionais', exemplo: true, selecionado: true},
          {nome: 'Calabresa', descricao: 'Calabresa fatiada, cebola e azeitonas', preco: 38, categoria: 'Pizzas Tradicionais', exemplo: true, selecionado: true},
          {nome: 'Portuguesa', descricao: 'Presunto, ovo, cebola, azeitona e ervilha', preco: 42, categoria: 'Pizzas Tradicionais', exemplo: true, selecionado: true},
          {nome: 'Frango com Catupiry', descricao: 'Frango desfiado com catupiry cremoso', preco: 40, categoria: 'Pizzas Tradicionais', exemplo: true, selecionado: true}
        ]
      },
      {
        nome: 'Pizzas Especiais',
        produtos: [
          {nome: 'Quatro Queijos', descricao: 'Mussarela, provolone, gorgonzola e parmesão', preco: 48, categoria: 'Pizzas Especiais', exemplo: true, selecionado: true},
          {nome: 'Pepperoni', descricao: 'Pepperoni importado com mussarela', preco: 45, categoria: 'Pizzas Especiais', exemplo: true, selecionado: true}
        ]
      },
      {
        nome: 'Bebidas',
        produtos: [
          {nome: 'Refrigerante 2L', descricao: 'Coca-Cola, Guaraná ou Fanta', preco: 12, categoria: 'Bebidas', exemplo: true, selecionado: true},
          {nome: 'Suco Natural 500ml', descricao: 'Laranja, limão ou maracujá', preco: 10, categoria: 'Bebidas', exemplo: true, selecionado: true}
        ]
      },
      {
        nome: 'Sobremesas',
        produtos: [
          {nome: 'Pizza de Chocolate', descricao: 'Chocolate ao leite com granulado', preco: 35, categoria: 'Sobremesas', exemplo: true, selecionado: true}
        ]
      }
    ]
  },

  'Hamburgueria': {
    segmento: 'Hamburgueria',
    icone: 'fas fa-hamburger',
    categorias: [
      {
        nome: 'Hambúrgueres',
        produtos: [
          {nome: 'X-Burger', descricao: 'Pão, hambúrguer 150g, queijo, alface e tomate', preco: 22, categoria: 'Hambúrgueres', exemplo: true, selecionado: true},
          {nome: 'X-Bacon', descricao: 'Pão, hambúrguer 150g, queijo, bacon crocante, alface e tomate', preco: 28, categoria: 'Hambúrgueres', exemplo: true, selecionado: true},
          {nome: 'X-Tudo', descricao: 'Pão, hambúrguer 180g, queijo, bacon, ovo, presunto, alface e tomate', preco: 32, categoria: 'Hambúrgueres', exemplo: true, selecionado: true},
          {nome: 'Smash Burger', descricao: 'Pão brioche, 2x smash 80g, queijo cheddar, cebola caramelizada', preco: 30, categoria: 'Hambúrgueres', exemplo: true, selecionado: true}
        ]
      },
      {
        nome: 'Combos',
        produtos: [
          {nome: 'Combo X-Burger', descricao: 'X-Burger + batata frita + refrigerante', preco: 35, categoria: 'Combos', exemplo: true, selecionado: true},
          {nome: 'Combo X-Bacon', descricao: 'X-Bacon + batata frita + refrigerante', preco: 42, categoria: 'Combos', exemplo: true, selecionado: true}
        ]
      },
      {
        nome: 'Porções',
        produtos: [
          {nome: 'Batata Frita', descricao: 'Porção de batata frita crocante', preco: 18, categoria: 'Porções', exemplo: true, selecionado: true},
          {nome: 'Onion Rings', descricao: 'Anéis de cebola empanados', preco: 20, categoria: 'Porções', exemplo: true, selecionado: true}
        ]
      },
      {
        nome: 'Bebidas',
        produtos: [
          {nome: 'Refrigerante Lata', descricao: 'Coca-Cola, Guaraná ou Fanta', preco: 7, categoria: 'Bebidas', exemplo: true, selecionado: true},
          {nome: 'Milk Shake', descricao: 'Chocolate, morango ou ovomaltine 400ml', preco: 18, categoria: 'Bebidas', exemplo: true, selecionado: true}
        ]
      }
    ]
  },

  'Açaí': {
    segmento: 'Açaí',
    icone: 'fas fa-ice-cream',
    categorias: [
      {
        nome: 'Açaí no Copo',
        produtos: [
          {nome: 'Açaí 300ml', descricao: 'Açaí batido com banana', preco: 15, categoria: 'Açaí no Copo', exemplo: true, selecionado: true},
          {nome: 'Açaí 500ml', descricao: 'Açaí batido com banana', preco: 22, categoria: 'Açaí no Copo', exemplo: true, selecionado: true},
          {nome: 'Açaí 700ml', descricao: 'Açaí batido com banana', preco: 28, categoria: 'Açaí no Copo', exemplo: true, selecionado: true}
        ]
      },
      {
        nome: 'Açaí na Barca',
        produtos: [
          {nome: 'Barca P (500ml)', descricao: 'Açaí com 3 complementos', preco: 25, categoria: 'Açaí na Barca', exemplo: true, selecionado: true},
          {nome: 'Barca G (1L)', descricao: 'Açaí com 5 complementos', preco: 40, categoria: 'Açaí na Barca', exemplo: true, selecionado: true}
        ]
      },
      {
        nome: 'Bebidas',
        produtos: [
          {nome: 'Água Mineral', descricao: '500ml com ou sem gás', preco: 4, categoria: 'Bebidas', exemplo: true, selecionado: true},
          {nome: 'Suco Natural', descricao: 'Laranja, morango ou maracujá', preco: 10, categoria: 'Bebidas', exemplo: true, selecionado: true}
        ]
      }
    ]
  },

  'Marmitaria': {
    segmento: 'Marmitaria',
    icone: 'fas fa-utensils',
    categorias: [
      {
        nome: 'Marmitas',
        produtos: [
          {nome: 'Marmita P', descricao: 'Arroz, feijão, salada e 1 proteína', preco: 18, categoria: 'Marmitas', exemplo: true, selecionado: true},
          {nome: 'Marmita M', descricao: 'Arroz, feijão, salada e 1 proteína + acompanhamento', preco: 22, categoria: 'Marmitas', exemplo: true, selecionado: true},
          {nome: 'Marmita G', descricao: 'Arroz, feijão, salada, 1 proteína + 2 acompanhamentos', preco: 28, categoria: 'Marmitas', exemplo: true, selecionado: true}
        ]
      },
      {
        nome: 'Pratos Executivos',
        produtos: [
          {nome: 'Executivo Frango Grelhado', descricao: 'Arroz, feijão, frango grelhado, farofa e salada', preco: 25, categoria: 'Pratos Executivos', exemplo: true, selecionado: true},
          {nome: 'Executivo Bife Acebolado', descricao: 'Arroz, feijão, bife acebolado, batata frita e salada', preco: 30, categoria: 'Pratos Executivos', exemplo: true, selecionado: true}
        ]
      },
      {
        nome: 'Bebidas',
        produtos: [
          {nome: 'Refrigerante Lata', descricao: 'Coca-Cola, Guaraná ou Fanta', preco: 6, categoria: 'Bebidas', exemplo: true, selecionado: true},
          {nome: 'Suco Natural', descricao: 'Laranja, limão ou maracujá', preco: 8, categoria: 'Bebidas', exemplo: true, selecionado: true}
        ]
      }
    ]
  }
};

export const TEMPLATE_GENERICO: SegmentoTemplate = {
  segmento: 'Outro',
  icone: 'fas fa-store',
  categorias: [
    {
      nome: 'Destaques',
      produtos: [
        {nome: 'Produto Exemplo 1', descricao: 'Descrição do produto', preco: 20, categoria: 'Destaques', exemplo: true, selecionado: true},
        {nome: 'Produto Exemplo 2', descricao: 'Descrição do produto', preco: 25, categoria: 'Destaques', exemplo: true, selecionado: true}
      ]
    },
    {
      nome: 'Bebidas',
      produtos: [
        {nome: 'Bebida Exemplo', descricao: 'Descrição da bebida', preco: 8, categoria: 'Bebidas', exemplo: true, selecionado: true}
      ]
    }
  ]
};

export function obtenhaTemplatePorSegmento(segmento: string): SegmentoTemplate {
  return TEMPLATES_SEGMENTO[segmento] || TEMPLATE_GENERICO;
}

const KEYWORDS_SEGMENTO: Record<string, string[]> = {
  'Pizzaria':     ['pizza', 'pizzaria'],
  'Hamburgueria': ['burger', 'hamburguer', 'hamburgueria', 'smash', 'x-burguer', 'xburguer'],
  'Açaí':        ['acai'],
  'Marmitaria':  ['marmita', 'marmitaria', 'quentinha', 'refeicao', 'self service', 'selfservice'],
  'Sushi':       ['sushi', 'japones', 'japones', 'temaki', 'sashimi', 'uramaki', 'niguiri', 'nigiri'],
  'Restaurante': ['restaurante', 'churrascaria', 'buffet', 'rodizio', 'frutos do mar', 'porcao', 'culinaria'],
  'Lanchonete':  ['lanche', 'lanchonete', 'sanduiche', 'hotdog', 'cachorro quente'],
  'Doceria':     ['doceria', 'confeitaria', 'brigadeiro', 'candy'],
  'Padaria':     ['padaria', 'panificadora', 'panificacao', 'croissant'],
  'Mercado':     ['mercado', 'supermercado', 'mercearia', 'hortifruti', 'emporio', 'minimercado'],
  'Pet Shop':    ['pet shop', 'petshop', 'veterinario', 'veterinaria', 'animais'],
  'Pastelaria':  ['pastel', 'pastelaria'],
};

export function detecteSegmentoPorTexto(texto: string): string | null {
  const normalizado = (texto || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9 ]/g, ' ');

  for (const [segmento, keywords] of Object.entries(KEYWORDS_SEGMENTO)) {
    if (keywords.some(kw => normalizado.includes(kw))) {
      return segmento;
    }
  }
  return null;
}
